import { purchasingAPI } from '../../lib/api';

/**
 * CR-7445: which purchase order a /purchasing deep link points at.
 *
 *   ?po_id=<database id>  what notifications and global search now send.
 *   ?po=<PO number>       what PoHeaderLink and the drill-downs send.
 *
 * PO notifications used to put the database id in ?po=, which the page looked
 * up as a PO number, so the link opened nothing (and an id equal to another
 * order's number would open the wrong one). Links already sitting in users'
 * notification lists still carry ?po=<id>, so a ?po= that matches no PO number
 * and is a whole number is tried as an id. The detail endpoint is scoped, so
 * an order the user cannot see resolves to null either way.
 */
export async function resolvePoDeepLink(
  params: { poId: string | null; po: string | null },
  api: Pick<typeof purchasingAPI, 'getOrder' | 'getOrders'> = purchasingAPI,
): Promise<number | null> {
  const byId = async (raw: string): Promise<number | null> => {
    if (!/^\d+$/.test(raw)) return null;
    try {
      const res = await api.getOrder(Number(raw));
      return res.data?.id ?? null;
    } catch {
      return null;
    }
  };

  if (params.poId) return byId(params.poId);
  if (!params.po) return null;
  try {
    const res = await api.getOrders({ po_number: params.po, page_size: 1 });
    const hit = res.data?.results?.[0];
    if (hit) return hit.id;
  } catch {
    // fall through to the legacy id form
  }
  return byId(params.po);
}
